import { isCurrentMobileAppVersionAbove } from "@faire/help-center-utils/lib/mobileAppVersion";
import { getSettingChatMobileEnabled } from "@faire/help-center-utils/settings/getSettingChatMobileEnabled";

const IOS_CHAT_SUPPORT_VERSION = "23.19.0";
const ANDROID_CHAT_SUPPORT_VERSION = "23.18.0";

export const isIOsChatEnabled = () => {
  return (
    getSettingChatMobileEnabled() &&
    isCurrentMobileAppVersionAbove(IOS_CHAT_SUPPORT_VERSION)
  );
};

export const isAndroidChatEnabled = () => {
  return (
    getSettingChatMobileEnabled() &&
    isCurrentMobileAppVersionAbove(ANDROID_CHAT_SUPPORT_VERSION)
  );
};
